<template>
    <section class="support">
        <div class="panel">
            <div class="panel-heading">
                <h2>Support<i class="clippie fa fa-info-circle" v-tooltip="'Open a support ticket and our teams will help you'"></i></h2>
            </div>
            <div v-if="supportTicketsAvailable === true" class="panel-body">
                <h4 class="support-legend-title">Department Contact</h4>
                <div class="col-xs-8 support-ledgend nopad">
                    <p><strong>Admissions</strong><br />
                        For questions about applying for another Think Tank program please email <a href="mailto:admissions@tttc.ca">admissions@tttc.ca</a>
                       <!-- <br><br><span class="xmas">Our admissions department will be closed Dec 18th until Jan 3rd so please expect a delay in response time during this holiday season.</span> -->
                    </p>

                    <p><strong>Program Management/Academics</strong><br />
                        For questions about class schedules, curriculum, lessons files, resources, grades or general academic support please email <a href="mailto:programmanagement@tttc.ca">programmanagement@tttc.ca</a>
                    </p>

                    <p><strong>Career Success</strong><br />
                        For help with your job hunt and other post-graduation support please email <a href="mailto:careerdev@tttc.ca">careerdev@tttc.ca</a>
                    </p>

                    <p><strong>Financial / Tuition / Payments</strong><br />
                        For any assistance with tuition payments, financial aid etc please email <a href="mailto:accounting@tttc.ca">accounting@tttc.ca</a>
                    </p>


                    <h4 class="support-legend-title secondary">Technical Support (Software) &amp; Portal Issues</h4>


                </div>
                <div class="col-xs-8 support-ledgend nopad">
                    <div class="">
                        <p><strong>Computer Support / Software Licensing</strong><br />Problems with installing software? Looking for recommended hardware specs? Something not working in Windows? Create a ticket today!
                        <br /><br />For any software specific questions, "UVs won't unwrap in Maya" for example, please post in your group chat channel or message your supervisor.</p>
                    </div>
                    <div class="">
                        <p><strong>Portal Issues</strong><br />
                            Experiencing a Portal / Chat issue that's hampering your learning experience? Let us know ASAP and create a ticket!
                        </p>
                        <p class="disclaimer">* Responses can take 24-36 business hours. Please keep in mind, we adopt normal business hours (9-5 Mon-Fri, Canadian holidays are also observed) and will answer to the best of our abilities within working hours (PST).</p>

                    </div>
                </div>
                <div class="col-xs-8 support-ledgend nopad">
                    <h2 class="ticket-form">Ticket Form</h2>
                    <div id="hubspotForm" v-once class="form-group col-xs-12 nopad"></div>
                </div>
            </div>
            <div v-else-if="supportTicketsAvailable === false" class="panel-body">
                <p>Support opens at 12 PM PT on the Tuesday before your first term begins. Check back then!</p>
            </div>
            <div v-else>
                <Loader></Loader>
            </div>
        </div>

        <div class="tickets" v-if="tickets">
            <div class="panel">
                <div class="panel-heading">
                    <h2>Old Support Tickets (Discontinued)<i class="clippie fa fa-info-circle" v-tooltip="'This ticket system will be discontinued, please create a new ticket above.'"></i></h2>
                </div>
                <div class="panel-body">
                    <ul class="list-group">
                        <li class="list-group-item ticket-wrapper" v-for="(ticket, index) in tickets" :id="'ticket_' + ticket.id ">
                            <div @click="openTicket(index)" class="content ticket-info row clearfix">
                                <div class="col-md-9">
                                    <p v-if="selectedTicket !==index">{{ticket.body | stripTags | truncate(2700)}}</p>
                                    <p v-else v-html="$options.filters.linkify(ticket.body)"></p>
                                </div>
                                <div class="col-md-3">
                                    <h5>Department: {{ticket.department | capitalize}}</h5>
                                    <div class="indent" v-if="ticket.department==='course' && ticket.tags.length > 0 && ticket.tags[0]">
                                        ({{ticket.tags | formatCourseTags}})
                                    </div>
                                    <div v-if="ticket.agent">
                                        <h5 class="representative">Representative:</h5>
                                        <div class="indent">{{ticket.agent.firstName}} {{ticket.agent.lastName}}</div>
                                    </div>
                                    <div class="resolved" v-if="ticket.resolved">Resolved</div>
                                </div>
                            </div>
                            <div v-if="selectedTicket===index">
                                <ul v-if="ticket.replies.length > 0" class="list-group replies">
                                    <li v-for="reply in ticket.replies" class="list-group-item" v-bind:class="{'from-me': isFromMe(reply.from) === true}">
                                        <div class="reply-body" v-html="$options.filters.linkify(reply.body)"></div>
                                    </li>
                                </ul>
                                <form @submit.prevent="replyToTicket(index)">
                                    <div class="form-group">
                                        <vue-html5-editor @change="updateReply" :content="ticket.reply"></vue-html5-editor>
                                    </div>
                                    <div class="form-group">
                                        <button class="btn btn-success" type="submit">Send</button>
                                    </div>
                                </form>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import toastr from 'toastr';
import VueScrollTo from 'vue-scrollto';
import support from '../services/support';
import Help from './widgets/Help.vue';
import users from '../services/users';
import Loader from './reusable/forum/loader.vue';

export default {
    data() {
        return {
            person: null,
            department: 'technical',
            message: '',
            tickets: null,
            selectedTicket: null,
            priorities: [{ level: 1, label: 'Urgent' }, { level: 2, label: 'High' }, { level: 3, label: 'Low' }, { level: 4, label: 'Not Pressing' }],
            priority: 3,
            supportTicketsAvailable: null
        }
    },
    components: {
        Help,
        Loader
    },
    async mounted() {
        await this.getPerson();
        let self = this;

        support.checkAvailability().then((response)=>{
            if (response.data.success === true) {
                this.supportTicketsAvailable = true;
                this.getTickets();
                const script = document.createElement("script");
                script.addEventListener("load", () => {
                    if (window.hbspt) {
                        console.log('HubSpot object found!')
                        window.hbspt.forms.create({
                            region: "na1",
                            portalId: "21570175",
                            formId: "a2499983-0d29-41ea-8993-1147502a0f1b",
                            target: "#hubspotForm",
                            onFormReady: function($form) {
                                // The HubSpot support form has a hidden email field. We don't want to leave it
                                // up to the student to populate that since they may enter a typo or some other
                                // address that isn't registered with their account. So let's set that for them.
                                $('#hubspotForm :input[name="email"]').val(self.person.email)
                                $('#hubspotForm :input[name="firstname"]').val(self.person.firstName)
                                $('#hubspotForm :input[name="lastname"]').val(self.person.lastName)
                            }
                        })
                    }
                })
                script.src="https://js.hsforms.net/forms/embed/v2.js";
                document.body.appendChild(script);
            } else {
                this.supportTicketsAvailable = false;            
            }
        });
    },
    methods: {
        slugify(name) {
            return name.replace(/100/g, '').trim().replace(/ /g, '_').toLowerCase();
        },
        openTicket(index) {
            var self = this;
            this.selectedTicket = index;
            let ticket = this.tickets[index];
            if (ticket && ticket.read !== true) {
                support.markAsRead(this, ticket.id).then(function() {
                    self.$bus.$emit('reload');
                });

            }
        },
        isFromMe(id) {
            return id == localStorage.user_id
        },
        updateMessage(content) {
            this.message = content
        },
        updateReply(content) {
            this.tickets[this.selectedTicket].reply = content;
        },
        getPerson() {
            let id;
            if (localStorage.roles.includes('Supervisor')) {
                id = localStorage.user_id;
            }
            return users.getMe(this, id).then((response) => {

                this.person = response.data.person;

                if (typeof this.person.socialLinks === 'string') {
                    try {
                        this.person.socialLinks = JSON.parse(JSON.parse(this.person.socialLinks)); //gd it wordpress
                    } catch (e) {
                        this.person.socialLinks = JSON.parse(this.person.socialLinks);
                    }
                }
                return true;
            });
        },
        getTickets() {
            var self = this;
            support.getTickets(this).then(function (response) {
                self.tickets = response.data.tickets;
                if (self.$route.query.ticket) {
                    self.selectedTicket = self.tickets.findIndex(function (t) {
                        return t.id == self.$route.query.ticket
                    });
                    let ticket = self.tickets[self.selectedTicket];

                    if (ticket) {
                        self.$nextTick(() => {
                            document.getElementById('ticket_' + ticket.id).scrollIntoView();
                        });
                        if (ticket.read !== true) {
                            support.markAsRead(this, ticket.id).then(function () {
                                self.$bus.$emit('reload');
                            });
                        }
                    }
                }
            });
        },
        replyToTicket(index) {
            var self = this;
            var ticket = this.tickets[index];
            var data = {
                body: ticket.reply,
                ticketId: ticket.id
            }
            support.replyToTicket(this, data).then(function (response) {
                if (response.data.success === true) {
                    $('.vue-html5-editor').children('.content').html('');

                    toastr.success('Reply sent');
                    self.getTickets();
                } else {
                    toastr.error('Failed to send reply');
                    self.getTickets();
                }
            });
        },
        watch: {
            '$route.query.ticket': function () {
                var self = this;
                self.selectedTicket = self.tickets.findIndex(function (t) {
                    return t.id == self.$route.query.ticket
                });
                VueScrollTo.scrollTo('#ticket_' + self.$route.query.ticket);
            }
        },
        computed: {
            currentTerm() {
                return this.$store.getters.currentTerm;
            }
        }
    }
}

</script>
<style lang="scss" scoped>
.left {
    padding-right:1rem;
}
.right {
    padding-left:1rem;
}
.support-ledgend {
    p {
        margin-bottom:2rem;
        strong {
            margin-bottom:.5rem;
            display:inline-block;
        }
    }
}
.support-legend-title.secondary {
    margin-top:3rem;
}
.indent {
    font-size: 12px;
    margin-left: 1rem;
}



.panel h2 {
    background: none;
}

.panel-body {
    padding: 20px !important;
}

.panel {
    padding: 0px !important;
}

.replies {
    li {
        background: transparent;
        margin-bottom: 2rem;

        &.from-me {
            border: 1px solid #43a4c8 !important;

        }

    }
}

.alert-success {
    background: none;
    font-style: italic;
    text-align: center;
}

.card {
    background: #222;
    padding: 1rem;
    margin-bottom: 2rem;
}

.tickets {
    background: #222222;

    .col-xs-12 {
        margin-top: 50px;
        padding-left: 5px;
        padding-right: 5px
    }

    .ticket-wrapper {
        border: solid 1px #000 !important;
        background: #363636;
        margin-bottom: 20px;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, .5);

    }

    .ticket-wrapper:hover {
        border-color: #333 !important;
        box-shadow: 0px 0px 5px rgba(51, 204, 255, .8);

        .initial-question {
            color: white !important;
        }
    }
}

.agent {
    font-weight: 700;
}

.from-them {
    background: #7A9E9F;
    color: #fff;
}

.card {
    background: #222;
    padding: 1rem;
    margin-bottom: 2rem;

}

.ticket {
    width: 320px;
    padding: 1rem;
}

.form-control:not([type="file"]) {
    border: solid 1px #999 !important;
    background-color: rgba(255, 255, 255, .05) !important;
}

.support-box {
    position: relative;
    top: 20px;
    clear: both;

    label {
        font-weight: 700 !important;
        color: #fff;
    }

    select {
        margin-bottom: 2rem;
    }

    .vue-html5-editor {
        border-radius: 5px;
    }
}

.support-ledged-title {}

.support-ledgend {
    strong {
        font-weight: 600;
        color: white;
    }
}

.ticket-info {
    padding-top: 10px;
    margin-bottom: 2rem;
    cursor: pointer;

    h5 {
        color: inherit;
        font-size: 15px !important;
        white-space: nowrap;
        margin: 0;
    }

    h5:nth-child(2) {
        margin-top: 1rem;
    }

    h5.representative {
        margin-top: 1rem;
    }

    .resolved {
        margin: 2rem 0;
        background: rgb(63, 235, 155);
        font-size: 2rem;
        padding: .5rem 2rem;
        color: #222;
        font-style: italic;
        display: inline-block;

    }
}

.disclaimer {
    font-size: 11px;
    margin-bottom:0!important;
}

.initial-question {
    //color:white;
    //margin-top: 10px;
    margin-bottom: 30px;
}

.reply-body {
    white-space: pre-wrap;
}

.xmas {
    color: red;
}
</style>
<style lang="scss">
.help {
    .panel-body {
        padding: 20px !important;
    }
}

.ticket-form {
    //color: #b0b0b0;
    font-weight: 400;
    font-size: 2.2rem;
}

// Style overrides for the embedded HubSpot form
#hubspotForm {
    input, select, textarea {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        outline: none;
        color: #f0f0f0;
        font-size: 15px;
        background-color:rgb(46, 46, 46) !important;
        border: none!important;
        border-bottom: 1px solid #fff!important;
        border-radius: 0!important;
        padding: 0.5rem!important;
    }

    select, textarea {
        width: 100%;
    }

    textarea {
        height: 200px;
    }

    label {
        padding: 8px 0px;
    }

    input#TICKET\.subject-a2499983-0d29-41ea-8993-1147502a0f1b {
        width: 100%;
    }

    input#TICKET\.subject-a2499983-0d29-41ea-8993-1147502a0f1b:focus {
        border-bottom: none;
    }

    input[type="submit"] {
        background-color: #33ccff !important;
        color: black;
        border-color: #002633;
        border-bottom: 1px solid #33ccff!important;
        padding: 10px 20px !important;
        font-size: 15px;
        line-height: 20px;
        margin-top: 5px;
    }

    fieldset {
        max-width: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// Support.vue?0ed8e9dc